
/// <reference path='../_all.ts' />

module shoppinglist {
  'use strict';

  export class Image {
    constructor(
      public Height: number,
      public Width: number,
      public OriginalHeight: number,
      public OriginalWidth: number,
      public RevDestId: number,
      public RevDestName: string,
      public TitleD: string,
      public TitleE: string,
      public MaxSideLength: number,
      public Url: string,
      public ImageUrl: string,
      public ImageUrlRetina: string
      )
    {
    }
  }
}